// extracted by mini-css-extract-plugin
export default {"warning":"AlertContainer_warning__8kL4C","title":"AlertContainer_title__cyfg9"};